import styled from 'styled-components'
import { ButtonUnstyled } from '../Button/ButtonUnstyled'
import { baseLinkStyle } from '../Link/Link.styles'

export const FakeLinkButton = styled(ButtonUnstyled)`
  ${baseLinkStyle}
`
